import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Grid, Segment } from 'semantic-ui-react'

import DriverNotification from '../../components/drivers/views/notification'

import DriverActions from '../../reducers/driverReducer'
import DriverSegmentActions from '../../reducers/driverSegmentReducer'

class Notification extends Component {

  componentDidMount() {
    const { driverLoaded, driverSegmentLoaded, syncDrivers, syncDriverSegments } = this.props

    if (!driverLoaded) {
      syncDrivers()
    }

    if (!driverSegmentLoaded) {
      syncDriverSegments()
    }
  }

  render() {
    const {
      driverLoading,
      drivers,
      driverSegments,
      driverSegmentLoading
    } = this.props

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <DriverNotification
                loading={driverLoading}
                drivers={drivers}
                driverSegments={driverSegments}
                driverSegmentLoading={driverSegmentLoading}
              />
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ drivers, driverSegments }) => ({
  driverLoaded: drivers.driverLoaded,
  driverLoading: drivers.driverLoading,
  drivers: _.map(drivers.drivers, (driver, driverUID) => ({ ...driver, driverUID })),

  driverSegments: driverSegments.driverSegments,
  driverSegmentLoaded: driverSegments.driverSegmentLoaded,
  driverSegmentLoading: driverSegments.driverSegmentLoading,
})

const mapDispatch = {
  syncDrivers: DriverActions.syncDrivers,
  syncDriverSegments: DriverSegmentActions.syncDriverSegments,
}

export default connect(
  mapState,
  mapDispatch
)(Notification)


// WEBPACK FOOTER //
// ./src/containers/notification/index.js